import type { ReactNode } from "react";

export function PageHeader({
  title,
  adornment,
  subtitle,
  actions,
}: {
  title: ReactNode;
  adornment?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="page-header">
      <div className="min-w-0">
        <div className="flex min-w-0 flex-wrap items-center gap-3">
          <h1>{title}</h1>
          {adornment}
        </div>
        {subtitle && <div className="page-subtitle">{subtitle}</div>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}
